import React, { useState, useEffect, useRef  } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./motorDetails.css";
import SelectionGraphique from "../Graphique/SelectionGraphique";
import DateForm from "./DateForm";
import { API_URL } from "../constants";
import { FaEdit } from "react-icons/fa";
import moment from "moment";
import 'leaflet/dist/leaflet.css';
import useModal from '../Modal/useModal';
import MotorImage from "./MotorImage";
import MotorDetailsFormNom from "./MotorDetailsFormNom";
import MotorDetailsFormCom from "./MotorDetailsFormCom";
import PdfReportButton from "./PdfReportButton";
import MaintenanceList from './MaintenanceList';
import AddMaintenance from "./AddMaintenance";
import TypoSelect from "./TypoSelect";
import axios from "axios";
import ErrorMessages from "./ErrorMessages";
import InfosMoteur from "./infosMoteur";
import ClientLocalisation from "./ClientLocalisation";
import EmailFrequencySelect from "./EmailFrequencySelect";
import EtalonnageMoteur from "./etalonnageMoteur";
import SetLimitCourantMoteur from "./SetLimitCourantMoteur";
import CheckConnectionSelect from "./CheckConnectionSelect";
import NoTrameSettings from "./NoTrameSettings";
import TempAlertSettings from "./TempAlertSettings";
import MotorErrorHistory from "./MotorErrorHistory";
import MotorReplacements from "./MotorReplacements";
import { useHistory } from "react-router-dom";
import { FaChevronDown } from 'react-icons/fa';
import RecalculMoyenneTrames from "./RecalculMoyenneTrames";


export default function MotorDetails(props) {
  const user = JSON.parse(localStorage.getItem("user")) ?? props.user;
  const token = user.token;
  const isAdmin = user && user.admin;
  const navigate = useHistory();
  const [expanded, setExpanded] = useState(false);
  const [expandedMaintenance, setExpandedMaintenance] = useState(false);
  const [motor, setMotor] = useState(
    localStorage.getItem("motor")
      ? JSON.parse(localStorage.getItem("motor"))
      : props.selectedMotor
  );
  const [editMode, setEditMode] = useState(false);
  const [showErrorDetails, setShowErrorDetails] = useState(false);
  const [maintenanceFreqIntervention, setMaintenanceFreqIntervention] = useState([]);
  const [isMaintenanceFreqModified, setIsMaintenanceFreqModified] = useState(false);
  const [showAddMaintenanceForm, setShowAddMaintenanceForm] = useState(false);
  const [newMaintenanceName, setNewMaintenanceName] = useState("");
  const [newFreqIntervention, setNewFreqIntervention] = useState("");
  const [isSuggestionClicked, setIsSuggestionClicked] = useState(false);
  const [error, setError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [lastTrame, setLastTrame] = useState("");
  const graphRef = useRef(null);
  const [dataPerPage, setDataPerPage] = useState(1440);
  const [loading, setLoading] = useState(false);
  const tempValue = lastTrame && (lastTrame.temperature ?? lastTrame.temp ?? lastTrame.ordonne ?? lastTrame.temperatureExt);
  const tempAlertTriggered = Boolean(
    motor?.tempAlertEnabled &&
      motor?.tempAlertThreshold !== null &&
      motor?.tempAlertThreshold !== undefined &&
      tempValue !== undefined &&
      tempValue !== null &&
      !isNaN(Number(tempValue)) &&
      Number(tempValue) > Number(motor.tempAlertThreshold)
  );
  const zeroCurrentTriggered = Boolean(motor?.zeroCurrentDetected === true);

  const showMessagePopup = (message) => {
    alert(message);
  };

  function getActiveMotorId(motor) {
    if (motor.id_moteurs_replace && motor.id_moteurs_replace.length > 0) {
      return motor.id_moteurs_replace[motor.id_moteurs_replace.length - 1];
    }
    return motor._id;
  }

  const activeMotorId = getActiveMotorId(motor);

  async function getActiveMaintenance(motor, token) {
    if (!motor.id_moteurs_replace || motor.id_moteurs_replace.length === 0) {
      return motor.maintenances;
    }

    try {
      const lastReplacementId = motor.id_moteurs_replace[motor.id_moteurs_replace.length - 1];

      const response = await axios.get(`${API_URL}/moteur/${motor._id}/remplacement`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: 'Bearer ' + token,
        },
      });

      if (response.status === 200 && response.data && response.data.remplacements) {
        const replacements = response.data.remplacements;
        const lastReplacement = replacements.find(r => r._id === lastReplacementId);

        if (lastReplacement && lastReplacement.maintenances) {
          return lastReplacement.maintenances;
        }

        return motor.maintenances;
      }
    } catch (error) {
      console.error(`Erreur lors de la récupération des maintenances : ${error.message}`);
      return motor.maintenances;
    }
  }

  useEffect(() => {
    let isMounted = true;

    async function fetchMaintenance() {
      const maintenances = await getActiveMaintenance(motor, token);
      if (isMounted && maintenances) {
        const hasChanged = JSON.stringify(motor.maintenances) !== JSON.stringify(maintenances);
        if (hasChanged) {
          setMotor(prev => ({ ...prev, maintenances }));
        }
      }
    }

    fetchMaintenance();

    return () => { isMounted = false; };
  }, [motor._id, token]);

  async function getTotalDureeFct(motor, token) {
    let totalDuree = motor.dureeFct || 0;

    if (motor.id_moteurs_replace && motor.id_moteurs_replace.length > 0) {
      try {
        const response = await axios.get(`${API_URL}/moteur/${motor._id}/remplacement`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });

        if (response.status === 200 && response.data && response.data.remplacements) {
          response.data.remplacements.forEach((replacement) => {
            if (replacement.dureeFct) {
              totalDuree += replacement.dureeFct;
            }
          });
        }
      } catch (error) {
        console.error(`Erreur lors de la récupération des remplacements : ${error.message}`);
      }
    }

    return totalDuree;
  }

  const [totalDuree, setTotalDuree] = useState(0);

  useEffect(() => {
    let isMounted = true;

    async function fetchTotalDuree() {
      const duree = await getTotalDureeFct(motor, token);
      if (isMounted) setTotalDuree(duree);
    }

    fetchTotalDuree();

    return () => { isMounted = false; };
  }, [motor._id, motor.dureeFct, token]);

  const clearMessages = () => {
    setTimeout(() => {
      setError("");
    }, 5000);
  };

  useEffect(() => {
    clearMessages();
  }, [error]);

  const { isShowing: isSuppModalShowing, toggle: toggleSuppModal } = useModal();

  const handleSuggestionClick = (suggestion) => {
    setNewMaintenanceName(suggestion.nomMaintenance);
    setNewFreqIntervention(suggestion.freqIntervention);
    setIsSuggestionClicked(true);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setNewMaintenanceName(value);
    setIsSuggestionClicked(false);
    setError("");
  };

  const handleMaintenanceFreqChange = (index, event) => {
    const newValue = parseInt(event.target.value);
    let tabFreqIntervention = [...maintenanceFreqIntervention];
    tabFreqIntervention[index] = newValue;
    setMaintenanceFreqIntervention([...tabFreqIntervention]);
    setIsMaintenanceFreqModified(newValue !== props.defaultMaintenanceFreq);
  };

  const toggleErrorDetails = () => {
    setShowErrorDetails(prevState => !prevState);
  };

  function isLongName(name) {
    const words = name.split(' ');
    return words.some(word => word.length > 10);
  }

  function truncateName(name) {
    const words = name.split(' ');
    const truncatedWords = words.map(word => {
      if (word.length > 10) {
        return word.substring(0, 10) + '...';
      }
      return word;
    });
    return truncatedWords.join(' ');
  }

  useEffect(() => {
    const activeMotorId = getActiveMotorId(motor);

    setDonnee((prev) => ({
      ...prev,
      idmoteur: activeMotorId,
    }));

    getTrame();
  }, [motor._id]);

  useEffect(() => {
    if (maintenanceFreqIntervention.length === 0) {
      let tabFreqIntervention = [];
      motor.maintenances.forEach((maintenance) => {
        tabFreqIntervention.push(maintenance.freqIntervention);
      });
      console.log(tabFreqIntervention);
      setMaintenanceFreqIntervention([...tabFreqIntervention]);
    }
  }, [motor]);

  const [positionAorB, setPositionAorB] = useState(true);
  const [donnee, setDonnee] = useState({
    idmoteur: getActiveMotorId(motor),
    debut: moment().format("YYYY-MM-DD"),
    fin: moment().format("YYYY-MM-DD"),
    position: "",
    granularity: "minute",
  });

  const [data, setData] = useState([]);
  const [recherche, setRecherche] = useState(false);

  function togglePosition() {
    setPositionAorB(!positionAorB);
    return;
  }

  async function getTrame() {
    try {
      setLoading(true);
      const newStartDate = moment(donnee.debut).subtract(1, 'day').format('YYYY-MM-DD');
      const newEndDate = moment(donnee.fin).add(1, 'day').format('YYYY-MM-DD');

      const buildUrl = (id) => {
        if (donnee.granularity === "hour") return `${API_URL}/tramesheure/heure?d1=${newStartDate}&d2=${newEndDate}&id=${id}`;
        if (donnee.granularity === "day") return `${API_URL}/tramesjour/jour?d1=${newStartDate}&d2=${newEndDate}&id=${id}`;
        return `${API_URL}/?d1=${newStartDate}&d2=${newEndDate}&id=${id}`;
      };

      const motorIds = [motor._id, ...(motor.id_moteurs_replace || [])];

      const requests = motorIds.map(id =>
        axios.get(buildUrl(id), {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        }).then(res => res.data.data || []).catch(err => {
          console.error(`Erreur sur le boîtier ${id} : ${err.message}`);
          return [];
        })
      );

      const results = await Promise.all(requests);

      const mergedData = results.flat().sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

      setData(mergedData);
      setRecherche(true);

      if (mergedData.length === 0) {
        setErrorMessage("ERREUR : Aucun capteur ne renvoie de données sur cette période.");
        return;
      }

      const lastTrameDate = moment(mergedData[mergedData.length - 1].timestamp);
      setLastTrame(mergedData[mergedData.length - 1]);

      if (donnee.granularity === "minute") {
        const now = moment();
        const duration = moment.duration(now.diff(lastTrameDate));
        if (duration.asDays() >= 7) {
          setErrorMessage('ERREUR : Le capteur ne renvoie plus de données depuis plus d’une semaine.');
        } else if (duration.asHours() >= 1) {
          const days = Math.floor(duration.asDays());
          const hours = duration.hours();
          let durationMessage = "Le capteur ne renvoie plus de données depuis ";
          if (days > 0) durationMessage += `${days} jours et `;
          if (hours > 0) durationMessage += `${hours} heures`;
          setErrorMessage(durationMessage);
        } else {
          setErrorMessage("");
        }
      } else {
        setErrorMessage("");
      }

      let perPage = 1440;
      if (donnee.granularity === "hour") perPage = 720;
      if (donnee.granularity === "day") perPage = 1464;
      setDataPerPage(perPage);

    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  }

  const ajouterMaintenance = async () => {
    if (!newMaintenanceName || !newFreqIntervention) {
      setError('Veuillez remplir tous les champs avant de valider !');
      return;
    }
    const freqIntervention = parseInt(newFreqIntervention);
    if (freqIntervention < 0) {
      setError("La fréquence d'intervention ne peut pas être négative !");
      return;
    }

    try {
      const response = await axios.post(
        `${API_URL}/typo/addmaintenance`,
        {
          id_moteur: motor._id,
          maintenance: {
            nomMaintenance: newMaintenanceName,
            freqIntervention: parseInt(newFreqIntervention),
            lastIntervention: motor.dureeFct,
          },
        },
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
        }
      );

      if (response.status === 401) {
        showMessagePopup('ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.');
        localStorage.clear();
        navigate.push('/login');
        return;
      }

      if (response.status === 200) {
        const json = response.data;
        console.log(json);
        setMotor(json);
        localStorage.setItem('motor', JSON.stringify(json));
        let tabFreqIntervention = [...maintenanceFreqIntervention];
        tabFreqIntervention.push(newFreqIntervention);
        setMaintenanceFreqIntervention(tabFreqIntervention);
        setNewMaintenanceName('');
        setNewFreqIntervention('');
        setShowAddMaintenanceForm(false);
      } else {
        console.error("Erreur lors de l'ajout de la maintenance");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loading) return;
    await getTrame();
  };

  useEffect(() => {
    positionAorB
      ? setDonnee({ ...donnee, position: "a" })
      : setDonnee({ ...donnee, position: "b" });
  }, [positionAorB]);

  return (
    <div className="min-h-screen flex flex-col text-base sm:text-3xl">
      <Header user={user} />
      <div className="flex flex-auto h-full w-full justify-center text-gray-700">
        <div className="flex flex-col items-center w-full">
          {(tempAlertTriggered || zeroCurrentTriggered) && (
            <div className="w-11/12 mt-4 space-y-3 flex flex-col items-stretch">
              {tempAlertTriggered && (
                <div className="bg-red-600 text-white p-4 rounded-2xl shadow-md flex items-start space-x-4" role="alert">
                  <div className="flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fillRule="evenodd" d="M6 2a2 2 0 114 0v7.268A4 4 0 1110 18a4 4 0 01-4-4V2zM8 2a1 1 0 10-2 0v7.268A3 3 0 008 15a3 3 0 003-3V2a1 1 0 10-2 0v7.268A1 1 0 018 10V2z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between">
                      <div className="font-semibold text-lg">Alerte température</div>
                      <div className="text-sm opacity-90">Seuil : {motor?.tempAlertThreshold ?? 'N/A'} °C</div>
                    </div>
                    <div className="mt-1 text-sm">
                      Température actuelle : {tempValue !== undefined && tempValue !== null ? Number(tempValue).toFixed(1) : 'N/A'} °C. Veuillez vérifier et intervenir si nécessaire.
                    </div>
                  </div>
                </div>
              )}

              {zeroCurrentTriggered && (
                <div className="bg-yellow-300 text-black p-4 rounded-2xl shadow-md flex items-start space-x-4" role="alert">
                  <div className="flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path d="M10 2a1 1 0 00-1 1v7H7a1 1 0 000 2h6a1 1 0 000-2h-2V3a1 1 0 00-1-1z" />
                      <path d="M4 15a2 2 0 002 2h8a2 2 0 002-2V9a1 1 0 10-2 0v6H6V9a1 1 0 10-2 0v6z" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <div className="font-semibold text-lg">Alerte courant</div>
                    <div className="mt-1 text-sm">
                      Le moteur semble arrêté.
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {isAdmin && (
            <ErrorMessages motor={motor} />
          )}
          {errorMessage && (
            <div className="bg-red-500 text-white py-4 px-6 cursor-pointer rounded-2xl mt-4 ">
              {errorMessage}
            </div>
          )}
          <div className="flex flex-col lg:flex-row w-11/12 p-4 space-y-4 lg:space-y-0 lg:space-x-4">
            <div className="border-solid border-4 border-bleuSTB rounded-lg p-8 lg:w-1/2">
              <h2
                className={`text-left${expanded ? 'cursor-pointer' : ''}`}
                onClick={() => setExpanded(!expanded)}
              >
                <div className="flex items-center justify-center">
                  {editMode ? (
                    <div>
                      {isAdmin ? (
                        <MotorDetailsFormNom
                          motor={motor}
                          setMotor={setMotor}
                          setEditMode={setEditMode}
                          token={token}
                        />
                      ) : (
                        <h2 className={`text-center text-loginBordure text-2xl mb-4 font-bold ${isLongName(motor.nom_moteur) && window.innerWidth < 1024 ? 'text-overflow' : ''}`}>{motor.nom_moteur}</h2>
                      )}
                    </div>
                  ) : (
                    <div className={`inline-flex items-center text-xl lg:text-5xl 3xl:text-6xl mb-4 font-bold text-marronSTB text-center ${isAdmin ? 'cursor-pointer' : ''}`}>
                      {isLongName(motor.nom_moteur) && window.innerWidth < 1024 ? (
                        <span className="text-overflow">{truncateName(motor.nom_moteur)}</span>
                      ) : (
                        <span>{motor.nom_moteur}</span>
                      )}
                      {isAdmin && (
                        <FaEdit
                          className="cursor-pointer text-xl 3xl:text-4xl ml-4 hover:text-bleuSTB"
                          onClick={(event) => {
                            event.stopPropagation();
                            setEditMode(!editMode);
                          }}
                        />
                      )}
                      {window.innerWidth < 1024 && (
                        <FaChevronDown
                          className={`ml-8 transition-transform duration-300 transform ${expanded ? 'rotate-180' : ''}`}
                        />
                      )}
                    </div>
                  )}
                </div>
                <div className={`${expanded ? 'block' : 'hidden'} ${window.innerWidth >= 1024 ? 'lg:block' : ''}`}>
                  <h4 className="border-solid border-4 border-r-0 border-l-0 border-bleuSTB pt-4 pb-4 text-xl 3xl:text-3xl tex underline">
                    <div className="inline-flex font-bold underline">
                      Commentaires
                      {!isAdmin && (
                        <FaEdit
                          className="cursor-pointer ml-4 hover:text-loginBordure"
                          onClick={(event) => {
                            event.stopPropagation();
                            setEditMode(!editMode);
                          }}
                        />
                      )}
                    </div>
                    {editMode ? (
                      <div>
                        <MotorDetailsFormCom motor={motor} setMotor={setMotor} setEditMode={setEditMode} token={token} />
                      </div>
                    ) : (
                      <div>
                        <span className="inline-block text-decoration-none font-light mb-4 mt-4">{motor.commentaire}</span>
                      </div>
                    )}
                  </h4>
                  {isAdmin && (
                    <h4 className="border-solid border-4 border-t-0 border-r-0 border-l-0 border-bleuSTB pt-4 pb-4 text-xl 3xl:text-3xl underline font-bold">
                      Niveau de champ Wi-Fi reçu
                      <br />
                      <span className="inline-block text-decoration-none font-light mb-4 mt-4">
                        {lastTrame.signal} dbm
                      </span>
                    </h4>
                  )}
                  <InfosMoteur motor={motor} token={token} setMotor={setMotor} />
                  <ClientLocalisation motor={motor} token={token} setMotor={setMotor} />
                  <EmailFrequencySelect motor={motor} token={token} setMotor={setMotor} />
                  {isAdmin && (
                    <EtalonnageMoteur motor={motor} token={token} setMotor={setMotor} />
                  )}
                  <SetLimitCourantMoteur motor={motor} token={token} setMotor={setMotor} />
                  <CheckConnectionSelect motor={motor} token={token} setMotor={setMotor} isAdmin={isAdmin} />
                  {isAdmin && (
                    <>
                      <NoTrameSettings motor={motor} token={token} setMotor={setMotor} />
                      <TempAlertSettings motor={motor} token={token} setMotor={setMotor} />
                      <RecalculMoyenneTrames motor={motor} token={token} />
                    </>
                  )}
                  <MotorErrorHistory motor={motor} token={token} />
                  {isAdmin && (
                    <MotorReplacements motor={motor} token={token} setMotor={setMotor} user={user} />
                  )}
                </div>
              </h2>
            </div>
            <div className="border-solid border-4 border-bleuSTB rounded-lg p-8 lg:w-1/2">
              <h2
                className={`items-center text-marronSTB font-bold text-xl xl:text-5xl 3xl:text-6xl cursor-pointer mb-4 flex`}
                onClick={() => setExpandedMaintenance(!expandedMaintenance)}
              >
                <div className="ml-auto mr-auto">Maintenance</div>
                {window.innerWidth < 1024 && (
                  <FaChevronDown
                    className={`ml-auto mr-auto transition-transform duration-300 transform ${expandedMaintenance ? 'rotate-180' : ''}`}
                  />
                )}
              </h2>
              {motor.maintenances.length > 0 ? (
                <div>
                  <div className={`${expandedMaintenance ? 'block' : 'hidden'} ${window.innerWidth >= 1024 ? 'lg:block' : ''}`}>
                    <h4 className="border-solid border-4 border-r-0 border-l-0 border-bleuSTB pt-4 pb-4 text-xl 3xl:text-3xl underline font-bold">
                      Durée de fonctionnement
                      <br />
                      <span className="inline-block text-decoration-none font-light mb-4 mt-4">{parseInt(totalDuree)} h</span>
                    </h4>
                    <MaintenanceList
                      motor={motor}
                      setMotor={setMotor}
                      token={token}
                      maintenanceFreqIntervention={maintenanceFreqIntervention}
                      handleMaintenanceFreqChange={handleMaintenanceFreqChange}
                      setIsMaintenanceFreqModified={setIsMaintenanceFreqModified}
                      showAddMaintenanceForm={showAddMaintenanceForm}
                      newMaintenanceName={newMaintenanceName}
                      newFreqIntervention={newFreqIntervention}
                      handleInputChange={handleInputChange}
                      ajouterMaintenance={ajouterMaintenance}
                      isSuppModalShowing={isSuppModalShowing}
                      toggleSuppModal={toggleSuppModal}
                      props={props}
                    />
                    <AddMaintenance
                      newMaintenanceName={newMaintenanceName}
                      handleInputChange={handleInputChange}
                      newFreqIntervention={newFreqIntervention}
                      setNewFreqIntervention={setNewFreqIntervention}
                      ajouterMaintenance={ajouterMaintenance}
                      error={error}
                      isSuggestionClicked={isSuggestionClicked}
                      handleSuggestionClick={handleSuggestionClick}
                      token={token}
                    />
                  </div>
                </div>
              ) : (
                <TypoSelect
                  props={props}
                  motor={motor}
                  setMotor={setMotor}
                  token={token}
                />
              )}
            </div>
          </div>
          <div className="flex flex-col w-10/12 sm:w-3/5 xl:w-[60%] xl:flex-row items-center border-4 border-bleuSTB rounded-2xl p-6">
            <DateForm
              donnee={donnee}
              setDonnee={setDonnee}
              handleSubmit={handleSubmit}
              loading={loading}
            />
            <div>
              <MotorImage
                positionAorB={positionAorB}
                togglePosition={togglePosition}
              />
            </div>
          </div>
          <div className="p-8">
            {isAdmin && recherche && data.length > 0 && (
              <div className="flex justify-end mb-4">
                <PdfReportButton
                  motor={motor}
                  donnee={donnee}
                  graphRef={graphRef}
                />
              </div>
            )}
            <div ref={graphRef}>
              {recherche ? (
                data.length > 0 ? (
                  <SelectionGraphique
                    data={data}
                    motor={motor}
                    type={motor.type}
                    freqAlim={motor.freqAlim}
                    freqRot={motor.freqRot}
                    position={donnee.position}
                    courantRef={motor.courantRef}
                    dataPerPage={dataPerPage}
                    granularity={donnee.granularity}
                    endDate={donnee.fin}
                    startDate={donnee.debut}
                  />
                ) : (
                  <span className="3xl:text-5xl">
                    Pas de données sur la période désirée
                  </span>
                )
              ) : (
                <p>
                  Veuillez sélectionner des dates pour obtenir les mesures
                  correspondantes
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}